import * as React from "react";

interface Props {
  height?: number;
  width?: number;
  fill?: string;
  style?: any;
}

const Add = ({ height = 800, width = 800, fill = '#000000', ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 76 76"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    baseProfile="full"
    enableBackground="new 0 0 76.00 76.00"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill={fill}
      fillOpacity={1}
      strokeWidth={0.2}
      strokeLinejoin="round"
      d="M 35,19L 41,19L 41,35L 57,35L 57,41L 41,41L 41,57L 35,57L 35,41L 19,41L 19,35L 35,35L 35,19 Z "
    />
  </svg>
);
export default Add;
